import { component as defineComponent } from 'flightjs';
import $ from 'jquery';
import Sortable from 'sortablejs';

function SortableList() {
    this.defaultAttrs({
        items: '[data-sortable-list-item]',
        'order-input': '[data-sortable-list-order-json]',
    });

    this.after('initialize', function () {
        new Sortable(this.node, { // eslint-disable-line no-new
            animation: 150,
            ghostClass: 'orderable-list__item--placeholder',
            onUpdate: this.updateOrderInput.bind(this),
        });
    });

    this.updateOrderInput = function () {
        this.select('order-input').val(this.getOrderArray());
    };

    this.getOrderArray = function () {
        return JSON.stringify($.map(this.select('items'), item => parseInt(item.getAttribute('data-sortable-list-item-id'), 10)));
    };
}

export default defineComponent(SortableList);



// WEBPACK FOOTER //
// ./src/js/component_ui/sortable-list.js